module.exports = __webpack_public_path__ + "assets/img/27_1253_big.1ec70970.jpg";